const configureHolidayToast = (state = null, action) => {
  if (action.type === "SET_CONFIGURE_HOLIDAY_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CONFIGURE_HOLIDAY_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default configureHolidayToast;
